import React, { useEffect } from "react";
import { Routes, Route, RouterProvider, createBrowserRouter, useNavigate } from "react-router-dom";
import { LoginPageContent } from "./login/login";
import { Playground } from "./playground";
import { Routing } from "./Routing";
import Cookies from "universal-cookie";
import { AuthRoutes } from "./AuthRoutes";
import RequireAuth from "./login/RequireAuth";

interface AppRoutesProps {

}
export function AppRoutes({ }: AppRoutesProps) {

    const cookies = new Cookies();
    let auth1 = cookies.get("auth");
    let navigate = useNavigate();

    // const router = createBrowserRouter([
    //     {
    //         path: "/form-builder",
    //         element: <AuthRoutes />,
    //     },
    //     {
    //         path: "/form-builder/*",
    //         element: <Routing />,
    //     },
    // ]);
    useEffect(() => {
        if (window.location.pathname === "/") {
            navigate("/");
        }
}, []);

    return (

        <Routes>
            {
                auth1 ? <Route element={<RequireAuth />}>
                    <Route path={"/*"} element={<Routing />} />
                </Route> : <Route path={"/*"} element={<AuthRoutes />} />
            }



        </Routes>
    );
}

interface BackgroundProps {

}

export function Background({ }: BackgroundProps) {

    return (

        <>

            <AppRoutes />
        </>

    );
}